import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, RequireAuth, RedirectIfAuthenticated } from './context/AuthContext';
import { useTrialStatus } from './hooks/useTrialStatus';
import TrialExpiredModal from './components/modals/TrialExpiredModal';
import AuthCard from './components/auth/AuthCard';
import DashboardPage from './pages/Dashboard/DashboardPage';
import Onboarding from './components/onboarding/Onboarding';
import ProductivityPage from './pages/Productivity/ProductivityPage';
import WellnessPage from './pages/Wellness/WellnessPage';
import GrowthPage from './pages/Growth/GrowthPage';
import FinancesPage from './pages/Finances/FinancesPage';
import SocialPage from './pages/Social/SocialPage';
import ProfilePage from './pages/ProfilePage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import './styles/global.css';

const AppContent = () => {
  const { showExpiredModal, handleContinue } = useTrialStatus();

  return (
    <>
      <TrialExpiredModal 
        isOpen={showExpiredModal} 
        onContinue={handleContinue} 
      />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={
          <RedirectIfAuthenticated>
            <AuthCard />
          </RedirectIfAuthenticated>
        } />
        <Route path="/verify-email" element={<EmailVerificationPage />} />

        {/* Protected routes */}
        <Route path="/dashboard" element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        } />
        <Route path="/onboarding" element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        } />
        <Route path="/productivity" element={
          <RequireAuth>
            <ProductivityPage />
          </RequireAuth>
        } />
        <Route path="/wellness" element={
          <RequireAuth>
            <WellnessPage />
          </RequireAuth>
        } />
        <Route path="/growth" element={
          <RequireAuth>
            <GrowthPage />
          </RequireAuth>
        } />
        <Route path="/finances" element={
          <RequireAuth>
            <FinancesPage />
          </RequireAuth>
        } />
        <Route path="/social" element={
          <RequireAuth>
            <SocialPage />
          </RequireAuth>
        } />
        <Route path="/profile" element={
          <RequireAuth>
            <ProfilePage />
          </RequireAuth>
        } />

        {/* Redirect root and any unknown routes */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
